import { useDomainEventStore } from "@/stores/useDomainEventStore";

export interface NotifyWorkflowSnapshotStaleInput {
  projectId: string;
  conversationId?: string | null;
  entityTypesAffected?: string[];
  source: string;
}

/**
 * Publishes a client-only `workflow.snapshot_stale` domain event so mounted
 * useWorkflowSnapshot listeners refetch GET workflow-snapshot. Call only after
 * a successful REST mutation that can change the workflow position or active Action Requests.
 * Does not contact the server; backend truth is updated by the preceding PATCH/POST.
 */
export function notifyWorkflowSnapshotStale(input: NotifyWorkflowSnapshotStaleInput): void {
  useDomainEventStore.getState().publishDomainEvent({
    eventType: "workflow.snapshot_stale",
    scope: {
      projectId: input.projectId,
      conversationId: input.conversationId ?? null,
    },
    entityTypesAffected: input.entityTypesAffected,
    source: input.source,
  });
}
